var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMouse = function SvgMouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.871 27.5v-15c0-5.523-4.398-10-9.824-10h-4.913c-5.426 0-9.824 4.477-9.824 10v15c0 5.523 4.398 10 9.824 10h4.913c5.426 0 9.824-4.477 9.824-10M.854 12.5C.854 5.594 6.349 0 13.134 0h4.913c6.785 0 12.28 5.594 12.28 12.5v15c0 6.906-5.495 12.5-12.28 12.5h-4.913C6.35 40 .854 34.406.854 27.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.459,
    height: 7.504,
    x: 14.356,
    y: 7.502,
    rx: 1.229
  }))));
};
export default SvgMouse;